module.exports = __webpack_public_path__ + "img/match-notification-symbol.b49ec0de.svg";